import React from "react";
import { AddressPrimary } from "../../../../../../interfaces/interfaces";
import LoadingSpinner from "../../../../../../components/LoadingSpinner/LoadingSpinner";

interface Props {
  addresses: AddressPrimary[];
  addressSelected: AddressPrimary | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  isLoading?: boolean;
}

export default function PrimaryAddressSelector({
  addresses,
  addressSelected,
  onChange,
  isLoading = false,
}: Props) {
  return (
    <tr>
      <th>Select Primary Address</th>
      <td className="address-selector-cell">
        <div className="address-selector-row">
          <select
            className="form-control address-selector-select"
            onChange={onChange}
            disabled={isLoading}
          >
            {addresses.map((addr, i) =>
              addr.locationCode.includes("3RDP") ? null : (
                <option
                  key={i}
                  value={i}
                  selected={addr.locationCode === addressSelected?.locationCode}
                >
                  {addr.locationCode} {addr.description}
                </option>
              ),
            )}
          </select>
          {isLoading && <LoadingSpinner inline />}
        </div>
      </td>
    </tr>
  );
}
